import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import { archivePayoutAccounts } from 'api/admin/businesses/businesses';

type useArchivePayoutAccountsPayload = {
  businessId: number;
  payoutAccountIds: number[];
};

export const useArchivePayoutAccounts = ({ successCallback }: { successCallback?: () => void }) => {
  return useMutation<unknown, AxiosError<{ error: string }>, useArchivePayoutAccountsPayload>({
    mutationFn: async ({ businessId, payoutAccountIds }: useArchivePayoutAccountsPayload) => {
      return archivePayoutAccounts({ businessId, payoutAccountIds });
    },
    onSuccess: async () => {
      successCallback?.();
      toaster('Successfully archived payout accounts', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);

      toaster(error?.response?.data?.error ?? 'Failed to archive payout accounts', {
        icon: '❌',
      });
    },
  });
};
